import { render, staticRenderFns } from "./aiBookExplantion.vue?vue&type=template&id=6bd72b9d&scoped=true&"
import script from "./aiBookExplantion.vue?vue&type=script&lang=js&"
export * from "./aiBookExplantion.vue?vue&type=script&lang=js&"
import style0 from "./aiBookExplantion.vue?vue&type=style&index=0&id=6bd72b9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd72b9d",
  null
  
)

export default component.exports